import React from "react";
import TextInput from "./form-components/TextInput";
import Switch from "./form-components/Switch";
import Checkbox from "./form-components/Checkbox";
import SelectInput from "./form-components/SelectInput";
import { AmountInput } from "./form-components/TextInput";
import { useFormContext } from "./context/FormContext";
import ButtonSimple, { ButtonOutline } from "@/components/ui/button-simple";

const industries = [
  { label: "Media & Entertainment", value: "media" },
  { label: "Technology", value: "tech" },
  { label: "Electronics Manufacturing", value: "electronics" },
  { label: "Retail & Wholesale", value: "retail" },
  { label: "E-commerce", value: "ecommerce" },
  { label: "Telecommunications", value: "telecom" },
  { label: "Healthcare", value: "healthcare" },
  { label: "Other", value: "other" },
];

const regions = [
  { label: "North America", value: "north-america" },
  { label: "Europe", value: "europe" },
  { label: "Asia Pacific", value: "asia-pacific" },
  { label: "Latin America", value: "latin-america" },
  { label: "Middle East & Africa", value: "middle-east-africa" },
];

const purchaseTimelines = [
  { label: "Within 1 week", value: "1week" },
  { label: "Within 1 month", value: "1month" },
  { label: "Within 3 months", value: "3months" },
  { label: "Within 6 months", value: "6months" },
  { label: "More than 6 months", value: "6months+" },
];

const BusinessBuyingProfile = () => {
  const { businessMethods, handleBack, handleFormSubmit } = useFormContext();
  const { register, formState, watch, setValue } = businessMethods;

  return (
    <form
      onSubmit={businessMethods.handleSubmit(data => handleFormSubmit(data, "business"))}
      className="mt-8 space-y-4"
    >
      <TextInput
        label="Company name"
        {...register("companyName")}
        error={formState.errors.companyName?.message}
      />

      <TextInput
        label="Company email"
        type="email"
        {...register("companyEmail")}
        error={formState.errors.companyEmail?.message}
      />

      <SelectInput
        label="Industry"
        value={watch("industry")}
        onChange={value => setValue("industry", value, { shouldValidate: true })}
        error={formState.errors.industry?.message}
        options={industries}
        placeholder="Select your industry"
      />

      <AmountInput
        label="Estimated purchase volume*"
        value={watch("purchaseVolume")}
        onChange={value => setValue("purchaseVolume", value, { shouldValidate: true })}
        error={formState.errors.purchaseVolume?.message}
        placeholder="Enter estimated volume"
      />

      <SelectInput
        label="Geographic region"
        value={watch("region")}
        onChange={value => setValue("region", value, { shouldValidate: true })}
        error={formState.errors.region?.message}
        options={regions}
        placeholder="Select your region"
      />

      <div className="pb-4 pt-4">
        <p className="mb-4 text-[15px] font-medium text-system-disabled">
          Help us tailor your experience. Share your notification preferences and future purchasing
          plans
        </p>

        <div>
          <p className="mb-[11px] text-sm text-system-titanium">Preferred notification method</p>
          <div className="flex gap-12">
            <Switch
              id="email-notifications"
              label="E-mail"
              checked={watch("notificationPreferences.email")}
              onCheckedChange={checked => setValue("notificationPreferences.email", checked)}
            />
            <Switch
              id="sms-notifications"
              label="SMS"
              checked={watch("notificationPreferences.sms")}
              onCheckedChange={checked => setValue("notificationPreferences.sms", checked)}
            />
          </div>
        </div>
      </div>

      <SelectInput
        label="When do you plan to purchase next?"
        value={watch("purchaseTimeline")}
        onChange={value => setValue("purchaseTimeline", value, { shouldValidate: true })}
        error={formState.errors.purchaseTimeline?.message}
        options={purchaseTimelines}
        placeholder="Select timeline"
      />

      <div className="pt-4">
        <Checkbox
          id="privacy-policy"
          checked={watch("privacyPolicy")}
          onCheckedChange={checked => setValue("privacyPolicy", checked, { shouldValidate: true })}
          error={formState.errors.privacyPolicy?.message}
          label="I confirm that I have read and agree to the Privacy Policy"
        />
      </div>

      <div className="flex gap-2.5 pt-2">
        <span className="w-full max-w-[110px]">
          <ButtonOutline type="button" onClick={handleBack} className="h-[42px]">
            Go back
          </ButtonOutline>
        </span>
        <span className="w-full max-w-[200px]">
          <ButtonSimple type="submit" className="h-[42px] rounded-lg text-white transition-colors">
            Join the waitlist
          </ButtonSimple>
        </span>
      </div>
    </form>
  );
};

export default BusinessBuyingProfile;
